import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Admin } from '@mol-limo-reg/admin-api';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EditAdminDialogComponent } from '../dialogs/edit-admin-dialog/edit-admin-dialog.component';
import { AddAdminDialogComponent } from '../dialogs/add-admin-dialog/add-admin-dialog.component';
import { ActivateAdminDialogComponent } from '../dialogs/activate-admin-dialog/activate-admin-dialog.component';
import { DeactivateAdminDialogComponent } from '../dialogs/deactivate-admin-dialog/deactivate-admin-dialog.component';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AdminService } from '../../services/admin.service';
import { DATE_SLASH_FORMAT } from '../../core/formatting/date-formatting';
import { catchError, of } from 'rxjs';
import { SnackbarService } from '../../services/snackbar.service';
import * as moment from 'moment';

@Component({
  selector: 'app-admins',
  templateUrl: './admins.component.html',
  styleUrls: ['./admins.component.scss'],
})
export class AdminsComponent implements OnInit {
  displayedColumns = ['name', 'email', 'createdAt', 'options'];
  pageSizeOptions = [5, 10, 20];

  dataSource = new MatTableDataSource<Admin>([]);
  loading = false;
  dataLength = 0;
  pageIndex = 0;
  pageSize = 5;

  constructor(
    private dialog: MatDialog,
    private snackbarService: SnackbarService,
    private adminService: AdminService,
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  openCreateAdminDialog() {
    let dialogRef = this.dialog.open(AddAdminDialogComponent, {
      autoFocus: 'dialog',
      width: '720px',
    });
    this.reloadAfterSuccessfulDialog(dialogRef);
  }

  openEditAdminDialogFor(admin: Admin) {
    let dialogRef = this.dialog.open(EditAdminDialogComponent, {
      data: admin,
      autoFocus: 'dialog',
      width: '720px',
    });
    this.reloadAfterSuccessfulDialog(dialogRef);
  }

  openActivateAdminDialogFor(admin: Admin) {
    let dialogRef = this.dialog.open(ActivateAdminDialogComponent, {
      data: admin,
      autoFocus: 'dialog',
      width: '720px',
    });
    this.reloadAfterSuccessfulDialog(dialogRef);
  }

  openDeactivateAdminDialogFor(admin: Admin) {
    let dialogRef = this.dialog.open(DeactivateAdminDialogComponent, {
      data: admin,
      autoFocus: 'dialog',
      width: '720px',
    });
    this.reloadAfterSuccessfulDialog(dialogRef);
  }

  formatDate(date: string) {
    return moment(date).format(DATE_SLASH_FORMAT);
  }

  dataAvailable() {
    return !(this.dataLength === 0) && !this.loading;
  }

  loadData() {
    this.loading = true;
    this.adminService
      .getAdmins$(this.pageSize, this.pageSize * this.pageIndex)
      .pipe(
        catchError(() => {
          this.snackbarService.error(`Az adminok lekérése során hiba lépett fel!`);
          this.loading = false;
          return of();
        }),
      )
      .subscribe((adminBatch) => {
        this.dataSource.data = adminBatch.items;
        this.dataLength = adminBatch.totalCount;
        this.loading = false;
      });
  }

  onPagination(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadData();
  }

  reloadAfterSuccessfulDialog(dialogRef: MatDialogRef<any>) {
    dialogRef.afterClosed().subscribe((result) => {
      if (result.success) {
        this.loadData();
      }
    });
  }
}
